import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './root-reducer';

import performanceMiddleware from './performance-middleware';
import { applyActors } from 'shared/utils/apply-actors';
import { getBiLoggingMiddleware } from 'shared/bi/middleware';
import { eventHandlers } from 'widget/analytics/bi';
import createIsolatedBIMiddleware from 'shared/bi/isolated/bi-middleware';
import biActionHandlers from 'widget/analytics/bi/action-handlers/all';


export default function configureStore(initialState = {}) {
  const { middleware: analyticMiddleware, actor: updateVodSettingsActor } =
    getBiLoggingMiddleware(eventHandlers);

  const isolatedBIMiddleware = createIsolatedBIMiddleware(biActionHandlers);

  // Compose final middleware and use devtools extension in debug environment
  const middlewares = [thunk, analyticMiddleware, isolatedBIMiddleware];

  if (__PROD__) {
    middlewares.push(performanceMiddleware);
  }

  if (__DEBUG__) {
    const reduxLogger = require('redux-logger').createLogger({
      collapsed: true,
      diff: true,
    });
    middlewares.push(reduxLogger);
  }

  let middleware = applyMiddleware(...middlewares);

  if (__DEBUG__) {
    if (window.devToolsExtension) {
      const devTools = window.devToolsExtension();
      middleware = compose(middleware, devTools);
    }
  }

  // Create final store and subscribe router in debug env ie. for devtools
  const store = middleware(createStore)(rootReducer, initialState);
  applyActors(store, [updateVodSettingsActor]);

  if (module.hot) {
    module.hot.accept('./root-reducer', () => {
      const nextRootReducer = require('./root-reducer').default;

      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}



// WEBPACK FOOTER //
// ./src/widget/redux/configure-store.js